import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import EditAccountInfoContainer from './EditAccountInfoContainer';
import EditContactContainer from './EditContactContainer';
import DeleteAccountContainer from "./DeleteAccountContainer";
import MailDeliverySettingContainer from "./MailDeliverySettingContainer";

import BackBar from "../../../../common/nav/BackBar";

import { useAppSelector } from "../../../../redux/hooks";
import { getMeta } from "../../../../redux/reducers/user";

import styles from "../DatabaseEntrySettingsPage.module.scss";

enum Drawers {
  AccountInfo,
  Contact,
  MailDelivery,
  Delete,
  None,
}

const OtherSettingsPage: React.FC = () => {
  const { t } = useTranslation();

  const [currentDrawer, setCurrentDrawer] = useState(Drawers.None);

  const meta = useAppSelector(getMeta);

  function genDrawers() {
    switch (currentDrawer) {
      case Drawers.AccountInfo:
        return (
          <EditAccountInfoContainer
            handleClose={() => {
              setCurrentDrawer(Drawers.None);
            }}
          />
        );
      case Drawers.Contact:
        return (
          <EditContactContainer
            full_name={meta?.full_name}
            gender={meta?.gender}
            birthday={meta?.birthday}
            prefecture={meta?.prefecture}
            address_line_1={meta?.address_line_1}
            address_line_2={meta?.address_line_2}
            phone={meta?.phone}
            // email={meta?.email}
            // is_public={meta?.is_public}
            handleClose={() => {
              setCurrentDrawer(Drawers.None);
            }}
          />
        );
      case Drawers.MailDelivery:
        return (
          <MailDeliverySettingContainer
            mailPreferences={meta?.mail_preferences}
            handleClose={() => {
              setCurrentDrawer(Drawers.None);
            }}
          />
        );
      case Drawers.Delete:
        return (
          <DeleteAccountContainer
            handleClose={() => {
              setCurrentDrawer(Drawers.None);
            }}
          />
        );
      default:
        return <></>;
    }
  }

  return (
    <main>
      {currentDrawer === Drawers.None ? (
        <div className={styles["p-dbsettings"]}>
          <div
            className={
              currentDrawer !== Drawers.None
                ? `${styles["p-dbsettings__wrapper"]} ${styles["hidden"]}`
                : styles["p-dbsettings__wrapper"]
            }
          >
            <BackBar
              title={t("その他設定")}
              editable={false}
              handleClose={() => history.back()}
            />
            <div className={styles["p-dbsettings__main"]}>
              <ul className={styles["p-dbsettings__main__triggerbox"]}>
                <li
                  className={styles["p-dbsettings__item"]}
                  onClick={() => setCurrentDrawer(Drawers.AccountInfo)}
                >
                  <div className={styles["p-dbsettings__item-title"]}>
                    {t("アカウント編集")}
                  </div>
                  <FontAwesomeIcon icon={["fal", "chevron-right"]} />
                </li>
                <li
                  className={styles["p-dbsettings__item"]}
                  onClick={() => setCurrentDrawer(Drawers.Contact)}
                >
                  <div className={styles["p-dbsettings__item-title"]}>
                    ご連絡先
                  </div>
                  <FontAwesomeIcon icon={["fal", "chevron-right"]} />
                </li>
                <li
                  className={styles["p-dbsettings__item"]}
                  onClick={() => setCurrentDrawer(Drawers.MailDelivery)}
                >
                  <div className={styles["p-dbsettings__item-title"]}>
                    メール配信設定
                  </div>
                  <FontAwesomeIcon icon={["fal", "chevron-right"]} />
                </li>
                <li
                  className={styles["p-dbsettings__item"]}
                  onClick={() => setCurrentDrawer(Drawers.Delete)}
                >
                  <div
                    className={`${styles["p-dbsettings__item-title"]} ${styles["delete"]}`}
                  >
                    アカウント削除
                  </div>
                  <FontAwesomeIcon icon={["fal", "chevron-right"]} />
                </li>
              </ul>
            </div>
          </div>
          <div
            className={
              currentDrawer !== Drawers.None
                ? `${styles["p-dbsettings__screen"]} ${styles["is-show"]}`
                : styles["p-dbsettings__screen"]
            }
            id="edit"
          ></div>
        </div>
      ) : (
        genDrawers()
      )}
    </main>
  );
};

export default OtherSettingsPage;
